import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Button,
  Grid,
  Breadcrumbs,
  Link,
  Typography,
  FormControl,
  CircularProgress,
  Backdrop,
  TextField,
  Box,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import axios from "axios";


//icons
import PrintIcon from "@material-ui/icons/Print"
import SearchIcon from '@material-ui/icons/Search';

// components
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import Table from "./components/Table/Table";

// styles
import useStyles from "./styles";

//helpers
import { BASE_URL } from "../../healpers/api";
import api from "../../healpers/apiRoutes";
//context
import { useUserState } from "../../context/UserContext";

export default function Page() {
  const classes = useStyles();
  const exportFunctionRef = useRef();

  //global
  var userState = useUserState();

  // local
  const [mainTableData, setmainTableData] = useState([]);
  const [fullPageLoader, setfullPageLoader] = useState(false);
  const [notification, setnotification] = useState(null);
  const [err, seterr] = useState(null);
  const [selectedSearchType, setSelectedSearchType] = useState('name')
  const [searchValue, setSearchValue] = useState()

  const handleSelectedSearchType = (event) => {
    setSelectedSearchType(event.target.value);
  };

  const fetchContacts = () => {
    setfullPageLoader(true);
    axios
      .get(BASE_URL + api.searchContacts, {
        params: { searchType: selectedSearchType, searchValue },
      })
      .then((res) => {
        setmainTableData(res.data?.data);
        setfullPageLoader(false);
      })
      .catch((err) => {
        console.log(err);
        seterr(err.response?.data?.msg);
        setTimeout(() => seterr(null), 3000);
        setfullPageLoader(false);
      });
  };

  useEffect(() => {
    if (userState.userData && searchValue) {
      fetchContacts();
    }
  }, [userState.userData, selectedSearchType]);

  return (
    <>
      <Container maxWidth={false}>
        <PageTitle
          title="All Contacts"
          breadCrump={
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" className={classes.link}>
                Brand Finder
              </Link>
              <Typography className={classes.link} color="primary">
                All Contacts
              </Typography>
            </Breadcrumbs>
          }
          rightAlignComponent={
            <>
              <form
                className={classes.root}
                noValidate
                autoComplete="off"
                style={{ minWidth: 750 }}
              >
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"spaceBetween"}
                >
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    size="small"
                  >
                    <InputLabel id="demo-simple-select-label">
                      Search Type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      defaultValue={selectedSearchType}
                      value={selectedSearchType}
                      onChange={handleSelectedSearchType}
                      label="Search Type"
                    >
                      <MenuItem value={"name"}>Name</MenuItem>
                      <MenuItem value={"email"}>Email</MenuItem>
                      <MenuItem value={"title"}>Title</MenuItem>
                      <MenuItem value={"domain"}>Domain</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    id="outlined-search"
                    label="Search"
                    variant="outlined"
                    fullWidth
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    size="small"
                    style={{ marginLeft: 20 }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    startIcon={<SearchIcon />}
                    disabled={!selectedSearchType || !searchValue}
                    onClick={fetchContacts}
                    style={{ minWidth: 150, marginLeft: 28 }}
                    
                  >
                    SEARCH
                  </Button>
                </Box>
              </form>
            </>
          }
        />
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Widget
              upperTitle
              noBodyPadding
              bodyClass={classes.tableOverflow}
              header={
                <div className={classes.mainChartHeader}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<PrintIcon />}
                    onClick={() => exportFunctionRef.current.onBtnExport()}
                  >
                    Export
                  </Button>
                </div>
              }
            >
              <Table ref={exportFunctionRef} tableData={mainTableData} />
            </Widget>
          </Grid>
        </Grid>
      </Container>
      <Backdrop className={classes.backdrop} open={fullPageLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {notification ? (
        <Alert
          severity="success"
          style={{ position: "absolute", bottom: 30, left: "48%" }}
        >
          {notification}
        </Alert>
      ) : (
        <></>
      )}
      {err ? (
        <Alert
          severity="error"
          style={{ position: "absolute", bottom: 30, left: "48%" }}
        >
          {err}
        </Alert>
      ) : (
        <></>
      )}
    </>
  );
}
